import Vue from 'vue'
import 'alpinejs'

import VTooltip from 'v-tooltip'

window.Bus = new Vue({ name: 'Bus' })

window.flash = function (message, type) {
    Bus.$emit('flash', message, type)
}

Vue.component('flash', require('./components/Flash.vue').default)
Vue.component('response-time', require('./components/StatusPage/ResponseTime.vue').default)

Vue.use(VTooltip)

new Vue({ el: '#statuspage' })
